import React from 'react';
import { bool, object, node, func } from 'prop-types';
import { resolve } from 'library/helpers/path-resolver';
import withData from 'util/hoc/with-data';
import QuestionContext from 'apps/journey/context/question-context';
import questionsQuery from 'apps/journey/queries/questionsQuery';

const StepQuestionsProvider = (props) => {
  const { graph_data, graph_update, children } = props;

  return (
    <QuestionContext.Provider
      value={{
        questions: resolve(graph_data, 'questions', []),
        updateQuestions: graph_update,
      }}
    >
      {children}
    </QuestionContext.Provider>
  );
};

StepQuestionsProvider.query = async (token, { uuid }) =>
  await questionsQuery('user_profile_steps', true, uuid);

StepQuestionsProvider.parseQueryData = (data) => ({
  questions: resolve(data, 'questions', []),
});

StepQuestionsProvider.propTypes = {
  graph_loading: bool,
  graph_data: object,
  graph_update: func,
  children: node,
};

export default withData(StepQuestionsProvider);
